import { BRAND_SOCIAL_ICONS } from "../config/brandAssets";
import { Images } from "../utility/image";

export const DEFAULT_WEBSITE_LOGO_URL = BRAND_SOCIAL_ICONS.logo;
export const DEFAULT_SITE_NAME = "Dream sports";

export const resolveWebsiteLogoUrl = (settings = {}) => {
  const custom = String(settings.websiteLogoUrl || "").trim();
  if (/^https?:\/\//i.test(custom)) return custom;
  return DEFAULT_WEBSITE_LOGO_URL;
};

export const resolveSiteDisplayName = (settings = {}) => {
  const name = String(settings.siteName || "").trim();
  return name || DEFAULT_SITE_NAME;
};

/** Branding for navbar, document title, and favicon. */
export const getWebsiteBrandingFromSettings = (settings = {}) => {
  const siteName = resolveSiteDisplayName(settings);
  const customLogo = String(settings.websiteLogoUrl || "").trim();
  const hasCustomLogo = /^https?:\/\//i.test(customLogo);

  return {
    siteName,
    logoUrl: hasCustomLogo ? customLogo : Images.mgHeaderLogo,
    faviconUrl: hasCustomLogo ? customLogo : DEFAULT_WEBSITE_LOGO_URL,
    localLogoFallback: Images.mgHeaderLogo,
  };
};
